/* eslint-disable comma-dangle */
const googleMapOptions = {
  nightThemeStyles: [
    {
      elementType: 'geometry',
      stylers: [
        {
          color: '#242f3e',
        },
      ],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#746855',
        },
      ],
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#242f3e',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#d59563',
        },
      ],
    },
    {
      featureType: 'poi',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#d59563',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#263c3f',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#6b9a76',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [
        {
          color: '#38414e',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#212a37',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#9ca5b3',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#746855',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#1f2835',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#f3d19c',
        },
      ],
    },
    {
      featureType: 'transit',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [
        {
          color: '#2f3948',
        },
      ],
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#d59563',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#17263c',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#515c6d',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#17263c',
        },
      ],
    },
  ],
}

const level2LocationDetails = [
  {
    code: 'vn-cmu',
    name: 'Cà Mau',
    level: 2,
  },
  {
    code: 'vn-blu',
    name: 'Bạc Liêu',
    level: 2,
  },
  {
    code: 'vn-stg',
    name: 'Sóc Trăng',
    level: 2,
  },
  {
    code: 'vn-vtu',
    name: 'Bà Rịa - Vũng Tàu',
    level: 2,
  },
  {
    code: 'vn-kgg',
    name: 'Kiên Giang',
    level: 2,
  },
  {
    code: 'vn-tvh',
    name: 'Trà Vinh',
    level: 2,
  },
  {
    code: 'vn-btn',
    name: 'Bình Thuận',
    level: 2,
  },
  {
    code: 'vn-bte',
    name: 'Bến Tre',
    level: 2,
  },
  {
    code: 'vn-hag',
    name: 'Hậu Giang',
    level: 2,
  },
  {
    code: 'vn-vlg',
    name: 'Vĩnh Long',
    level: 2,
  },
  {
    code: 'vn-cto',
    name: 'Cần Thơ',
    level: 2,
  },
  {
    code: 'vn-dtp',
    name: 'Đồng Tháp',
    level: 2,
  },
  {
    code: 'vn-hcm',
    name: 'Hồ Chí Minh',
    level: 2,
  },
  {
    code: 'vn-tgg',
    name: 'Tiền Giang',
    level: 2,
  },
  {
    code: 'vn-agg',
    name: 'An Giang',
    level: 2,
  },
  {
    code: 'vn-lan',
    name: 'Long An',
    level: 2,
  },
  {
    code: 'vn-dni',
    name: 'Đồng Nai',
    level: 2,
  },
  {
    code: 'vn-ntn',
    name: 'Ninh Thuận',
    level: 2,
  },
  {
    code: 'vn-bdg',
    name: 'Bình Dương',
    level: 2,
  },
  {
    code: 'vn-tnh',
    name: 'Tây Ninh',
    level: 2,
  },
  {
    code: 'vn-ldg',
    name: 'Lâm Đồng',
    level: 2,
  },
  {
    code: 'vn-bpc',
    name: 'Bình Phước',
    level: 2,
  },
  {
    code: 'vn-kha',
    name: 'Khánh Hòa',
    level: 2,
  },
  {
    code: 'vn-dnk',
    name: 'Đắk Nông',
    level: 2,
  },
  {
    code: 'vn-dlk',
    name: 'Đắk Lắk',
    level: 2,
  },
  {
    code: 'vn-pyn',
    name: 'Phú Yên',
    level: 2,
  },
  {
    code: 'vn-gli',
    name: 'Gia Lai',
    level: 2,
  },
  {
    code: 'vn-bdh',
    name: 'Bình Định',
    level: 2,
  },
  {
    code: 'vn-ktm',
    name: 'Kon Tum',
    level: 2,
  },
  {
    code: 'vn-qni',
    name: 'Quảng Ngãi',
    level: 2,
  },
  {
    code: 'vn-qnm',
    name: 'Quảng Nam',
    level: 2,
  },
  {
    code: 'vn-dng',
    name: 'Đà Nẵng',
    level: 2,
  },
  {
    code: 'vn-tth',
    name: 'Thừa Thiên - Huế',
    level: 2,
  },
  {
    code: 'vn-qti',
    name: 'Quảng Trị',
    level: 2,
  },
  {
    code: 'vn-qbh',
    name: 'Quảng Bình',
    level: 2,
  },
  {
    code: 'vn-hth',
    name: 'Hà Tĩnh',
    level: 2,
  },
  {
    code: 'vn-nan',
    name: 'Nghệ An',
    level: 2,
  },
  {
    code: 'vn-tha',
    name: 'Thanh Hóa',
    level: 2,
  },
  {
    code: 'vn-nbh',
    name: 'Ninh Bình',
    level: 2,
  },
  {
    code: 'vn-ndh',
    name: 'Nam Định',
    level: 2,
  },
  {
    code: 'vn-tbh',
    name: 'Thái Bình',
    level: 2,
  },
  {
    code: 'vn-hbh',
    name: 'Hòa Bình',
    level: 2,
  },
  {
    code: 'vn-hnm',
    name: 'Hà Nam',
    level: 2,
  },
  {
    code: 'vn-hpg',
    name: 'Hải Phòng',
    level: 2,
  },
  {
    code: 'vn-qnh',
    name: 'Quảng Ninh',
    level: 2,
  },
  {
    code: 'vn-hni',
    name: 'Hà Nội',
    level: 2,
  },
  {
    code: 'vn-sla',
    name: 'Sơn La',
    level: 2,
  },
  {
    code: 'vn-hyn',
    name: 'Hưng Yên',
    level: 2,
  },
  {
    code: 'vn-hdg',
    name: 'Hải Dương',
    level: 2,
  },
  {
    code: 'vn-dbn',
    name: 'Điện Biên',
    level: 2,
  },
  {
    code: 'vn-pto',
    name: 'Phú Thọ',
    level: 2,
  },
  {
    code: 'vn-bnh',
    name: 'Bắc Ninh',
    level: 2,
  },
  {
    code: 'vn-bgg',
    name: 'Bắc Giang',
    level: 2,
  },
  {
    code: 'vn-vpc',
    name: 'Vĩnh Phúc',
    level: 2,
  },
  {
    code: 'vn-lsn',
    name: 'Lạng Sơn',
    level: 2,
  },
  {
    code: 'vn-tnn',
    name: 'Thái Nguyên',
    level: 2,
  },
  {
    code: 'vn-ybi',
    name: 'Yên Bái',
    level: 2,
  },
  {
    code: 'vn-tqg',
    name: 'Tuyên Quang',
    level: 2,
  },
  {
    code: 'vn-lcu',
    name: 'Lai Châu',
    level: 2,
  },
  {
    code: 'vn-bkn',
    name: 'Bắc Kạn',
    level: 2,
  },
  {
    code: 'vn-lci',
    name: 'Lào Cai',
    level: 2,
  },
  {
    code: 'vn-hgg',
    name: 'Hà Giang',
    level: 2,
  },
  {
    code: 'vn-cbg',
    name: 'Cao Bằng',
    level: 2,
  },
]

const level3LocationDetails = [
  {
    code: 'vn-cmu-ngn',
    name: 'Ngọc Hiển',
    level: 3,
  },
  {
    code: 'vn-vtu-coo',
    name: 'Côn Đảo',
    level: 3,
  },
  {
    code: 'vn-kha-tra',
    name: 'Trường Sa',
    level: 3,
  },
  {
    code: 'vn-cmu-nan',
    name: 'Năm Căn',
    level: 3,
  },
  {
    code: 'vn-cmu-phn',
    name: 'Phú Tân',
    level: 3,
  },
  {
    code: 'vn-cmu-dai',
    name: 'Đầm Dơi',
    level: 3,
  },
  {
    code: 'vn-cmu-cac',
    name: 'Cái Nước',
    level: 3,
  },
  {
    code: 'vn-cmu-trn',
    name: 'Trần Văn Thời',
    level: 3,
  },
  {
    code: 'vn-blu-doi',
    name: 'Đông Hải',
    level: 3,
  },
  {
    code: 'vn-cmu-cau',
    name: 'Cà Mau',
    level: 3,
  },
  {
    code: 'vn-blu-hoh',
    name: 'Hoà Bình',
    level: 3,
  },
  {
    code: 'vn-blu-gii',
    name: 'Giá Rai',
    level: 3,
  },
  {
    code: 'vn-cmu-umh',
    name: 'U Minh',
    level: 3,
  },
  {
    code: 'vn-blu-bau',
    name: 'Bạc Liêu',
    level: 3,
  },
  {
    code: 'vn-cmu-thh',
    name: 'Thới Bình',
    level: 3,
  },
  {
    code: 'vn-stg-viu',
    name: 'Vĩnh Châu',
    level: 3,
  },
  {
    code: 'vn-blu-vii',
    name: 'Vĩnh Lợi',
    level: 3,
  },
  {
    code: 'vn-blu-phg',
    name: 'Phước Long',
    level: 3,
  },
  {
    code: 'vn-stg-myn',
    name: 'Mỹ Xuyên',
    level: 3,
  },
  {
    code: 'vn-blu-hon',
    name: 'Hồng Dân',
    level: 3,
  },
  {
    code: 'vn-stg-thi',
    name: 'Thạnh Trị',
    level: 3,
  },
  {
    code: 'vn-kgg-vin',
    name: 'Vĩnh Thuận',
    level: 3,
  },
  {
    code: 'vn-stg-tre',
    name: 'Trần Đề',
    level: 3,
  },
  {
    code: 'vn-stg-ngm',
    name: 'Ngã Năm',
    level: 3,
  },
  {
    code: 'vn-kgg-utg',
    name: 'U Minh Thượng',
    level: 3,
  },
  {
    code: 'vn-stg-cuo',
    name: 'Cù Lao Dung',
    level: 3,
  },
  {
    code: 'vn-kgg-anh',
    name: 'An Minh',
    level: 3,
  },
  {
    code: 'vn-stg-myu',
    name: 'Mỹ Tú',
    level: 3,
  },
  {
    code: 'vn-tvh-duih',
    name: 'Duyên Hải',
    level: 3,
  },
  {
    code: 'vn-stg-lou',
    name: 'Long Phú',
    level: 3,
  },
  {
    code: 'vn-stg-sog',
    name: 'Sóc Trăng',
    level: 3,
  },
  {
    code: 'vn-tvh-duitx',
    name: 'Duyên Hải',
    level: 3,
  },
  {
    code: 'vn-hag-ngyh',
    name: 'Long Mỹ',
    level: 3,
  },
  {
    code: 'vn-kgg-goo',
    name: 'Gò Quao',
    level: 3,
  },
  {
    code: 'vn-stg-chh',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-tvh-tru',
    name: 'Trà Cú',
    level: 3,
  },
  {
    code: 'vn-hag-loy',
    name: 'Long Mỹ',
    level: 3,
  },
  {
    code: 'vn-hag-php',
    name: 'Phụng Hiệp',
    level: 3,
  },
  {
    code: 'vn-tvh-cng',
    name: 'Cầu Ngang',
    level: 3,
  },
  {
    code: 'vn-hag-vih',
    name: 'Vị Thanh',
    level: 3,
  },
  {
    code: 'vn-hag-viy',
    name: 'Vị Thủy',
    level: 3,
  },
  {
    code: 'vn-kgg-ann',
    name: 'An Biên',
    level: 3,
  },
  {
    code: 'vn-stg-keh',
    name: 'Kế Sách',
    level: 3,
  },
  {
    code: 'vn-tvh-tin',
    name: 'Tiểu Cần',
    level: 3,
  },
  {
    code: 'vn-kgg-kii',
    name: 'Kiên Hải',
    level: 3,
  },
  {
    code: 'vn-tvh-cae',
    name: 'Cầu Kè',
    level: 3,
  },
  {
    code: 'vn-hag-ngytx',
    name: 'Ngã Bảy',
    level: 3,
  },
  {
    code: 'vn-tvh-chh',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-bte-thu',
    name: 'Thạnh Phú',
    level: 3,
  },
  {
    code: 'vn-kgg-gig',
    name: 'Giồng Riềng',
    level: 3,
  },
  {
    code: 'vn-kgg-chh',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-hag-cth',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-tvh-clg',
    name: 'Càng Long',
    level: 3,
  },
  {
    code: 'vn-hag-cta',
    name: 'Châu Thành A',
    level: 3,
  },
  {
    code: 'vn-vlg-trn',
    name: 'Trà Ôn',
    level: 3,
  },
  {
    code: 'vn-tvh-trh',
    name: 'Trà Vinh',
    level: 3,
  },
  {
    code: 'vn-cto-thi',
    name: 'Thới Lai',
    level: 3,
  },
  {
    code: 'vn-kgg-raa',
    name: 'Rạch Giá',
    level: 3,
  },
  {
    code: 'vn-vlg-vum',
    name: 'Vũng Liêm',
    level: 3,
  },
  {
    code: 'vn-cto-phn',
    name: 'Phong Điền',
    level: 3,
  },
  {
    code: 'vn-cto-cag',
    name: 'Cái Răng',
    level: 3,
  },
  {
    code: 'vn-kgg-tap',
    name: 'Tân Hiệp',
    level: 3,
  },
  {
    code: 'vn-bte-bai',
    name: 'Ba Tri',
    level: 3,
  },
  {
    code: 'vn-vlg-tah',
    name: 'Tam Bình',
    level: 3,
  },
  {
    code: 'vn-bte-mcn',
    name: 'Mỏ Cày Nam',
    level: 3,
  },
  {
    code: 'vn-vlg-bih',
    name: 'Bình Minh',
    level: 3,
  },
  {
    code: 'vn-cto-niu',
    name: 'Ninh Kiều',
    level: 3,
  },
  {
    code: 'vn-cto-biy',
    name: 'Bình Thủy',
    level: 3,
  },
  {
    code: 'vn-cto-coo',
    name: 'Cờ Đỏ',
    level: 3,
  },
  {
    code: 'vn-bte-gim',
    name: 'Giồng Trôm',
    level: 3,
  },
  {
    code: 'vn-bte-bii',
    name: 'Bình Đại',
    level: 3,
  },
  {
    code: 'vn-kgg-hot',
    name: 'Hòn Đất',
    level: 3,
  },
  {
    code: 'vn-cto-omn',
    name: 'Ô Môn',
    level: 3,
  },
  {
    code: 'vn-vlg-bin',
    name: 'Bình Tân',
    level: 3,
  },
  {
    code: 'vn-bte-mcb',
    name: 'Mỏ Cày Bắc',
    level: 3,
  },
  {
    code: 'vn-cto-vih',
    name: 'Vĩnh Thạnh',
    level: 3,
  },
  {
    code: 'vn-vlg-mat',
    name: 'Mang Thít',
    level: 3,
  },
  {
    code: 'vn-vlg-loo',
    name: 'Long Hồ',
    level: 3,
  },
  {
    code: 'vn-dtp-lag',
    name: 'Lai Vung',
    level: 3,
  },
  {
    code: 'vn-kgg-kig',
    name: 'Kiên Lương',
    level: 3,
  },
  {
    code: 'vn-bte-coh',
    name: 'Chợ Lách',
    level: 3,
  },
  {
    code: 'vn-dtp-chh',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-cto-tht',
    name: 'Thốt Nốt',
    level: 3,
  },
  {
    code: 'vn-agg-thn',
    name: 'Thoại Sơn',
    level: 3,
  },
  {
    code: 'vn-bte-bee',
    name: 'Bến Tre',
    level: 3,
  },
  {
    code: 'vn-tgg-tau',
    name: 'Tân Phú Đông',
    level: 3,
  },
  {
    code: 'vn-vlg-vig',
    name: 'Vĩnh Long',
    level: 3,
  },
  {
    code: 'vn-bte-cah',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-dtp-sac',
    name: 'Sa Đéc',
    level: 3,
  },
  {
    code: 'vn-tgg-gcd',
    name: 'Gò Công Đông',
    level: 3,
  },
  {
    code: 'vn-agg-trn',
    name: 'Tri Tôn',
    level: 3,
  },
  {
    code: 'vn-tgg-cae',
    name: 'Cái Bè',
    level: 3,
  },
  {
    code: 'vn-tgg-gct',
    name: 'Gò Công Tây',
    level: 3,
  },
  {
    code: 'vn-tgg-cayh',
    name: 'Cai Lậy',
    level: 3,
  },
  {
    code: 'vn-dtp-lao',
    name: 'Lấp Vò',
    level: 3,
  },
  {
    code: 'vn-dtp-cahh',
    name: 'Cao Lãnh',
    level: 3,
  },
  {
    code: 'vn-tgg-cho',
    name: 'Chợ Gạo',
    level: 3,
  },
  {
    code: 'vn-agg-lon',
    name: 'Long Xuyên',
    level: 3,
  },
  {
    code: 'vn-kgg-han',
    name: 'Hà Tiên',
    level: 3,
  },
  {
    code: 'vn-tgg-chh',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-tgg-myo',
    name: 'Mỹ Tho',
    level: 3,
  },
  {
    code: 'vn-vtu-vuu',
    name: 'Vũng Tàu',
    level: 3,
  },
  {
    code: 'vn-agg-chi',
    name: 'Chợ Mới',
    level: 3,
  },
  {
    code: 'vn-tgg-gco',
    name: 'Gò Công',
    level: 3,
  },
  {
    code: 'vn-agg-chh',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-kgg-gih',
    name: 'Giang Thành',
    level: 3,
  },
  {
    code: 'vn-tgg-caytx',
    name: 'Cai Lậy',
    level: 3,
  },
  {
    code: 'vn-dtp-thi',
    name: 'Tháp Mười',
    level: 3,
  },
  {
    code: 'vn-hcm-cao',
    name: 'Cần Giờ',
    level: 3,
  },
  {
    code: 'vn-vtu-lon',
    name: 'Long Điền',
    level: 3,
  },
  {
    code: 'vn-vtu-dao',
    name: 'Đất Đỏ',
    level: 3,
  },
  {
    code: 'vn-lan-chh',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-dtp-cahtp',
    name: 'Cao Lãnh',
    level: 3,
  },
  {
    code: 'vn-tgg-tac',
    name: 'Tân Phước',
    level: 3,
  },
  {
    code: 'vn-agg-tin',
    name: 'Tịnh Biên',
    level: 3,
  },
  {
    code: 'vn-lan-cdc',
    name: 'Cần Đước',
    level: 3,
  },
  {
    code: 'vn-agg-chu',
    name: 'Châu Phú',
    level: 3,
  },
  {
    code: 'vn-vtu-xuc',
    name: 'Xuyên Mộc',
    level: 3,
  },
  {
    code: 'vn-vtu-baa',
    name: 'Bà Rịa',
    level: 3,
  },
  {
    code: 'vn-lan-tau',
    name: 'Tân Trụ',
    level: 3,
  },
  {
    code: 'vn-vtu-phy',
    name: 'Phú Mỹ',
    level: 3,
  },
  {
    code: 'vn-lan-tan',
    name: 'Tân An',
    level: 3,
  },
  {
    code: 'vn-lan-cgc',
    name: 'Cần Giuộc',
    level: 3,
  },
  {
    code: 'vn-btn-phy',
    name: 'Phú Quý',
    level: 3,
  },
  {
    code: 'vn-dtp-thh',
    name: 'Thanh Bình',
    level: 3,
  },
  {
    code: 'vn-lan-tah',
    name: 'Tân Thạnh',
    level: 3,
  },
  {
    code: 'vn-vtu-chc',
    name: 'Châu Đức',
    level: 3,
  },
  {
    code: 'vn-agg-phn',
    name: 'Phú Tân',
    level: 3,
  },
  {
    code: 'vn-lan-tta',
    name: 'Thủ Thừa',
    level: 3,
  },
  {
    code: 'vn-btn-hta',
    name: 'Hàm Tân',
    level: 3,
  },
  {
    code: 'vn-lan-tha',
    name: 'Thạnh Hóa',
    level: 3,
  },
  {
    code: 'vn-hcm-nhe',
    name: 'Nhà Bè',
    level: 3,
  },
  {
    code: 'vn-dni-nhh',
    name: 'Nhơn Trạch',
    level: 3,
  },
  {
    code: 'vn-lan-bec',
    name: 'Bến Lức',
    level: 3,
  },
  {
    code: 'vn-agg-chc',
    name: 'Châu Đốc',
    level: 3,
  },
  {
    code: 'vn-hcm-bic',
    name: 'Bình Chánh',
    level: 3,
  },
  {
    code: 'vn-btn-lai',
    name: 'La Gi',
    level: 3,
  },
  {
    code: 'vn-dni-lot',
    name: 'Long Thành',
    level: 3,
  },
  {
    code: 'vn-dtp-tng',
    name: 'Tam Nông',
    level: 3,
  },
  {
    code: 'vn-lan-moa',
    name: 'Mộc Hóa',
    level: 3,
  },
  {
    code: 'vn-lan-tag',
    name: 'Tân Hưng',
    level: 3,
  },
  {
    code: 'vn-dni-cay',
    name: 'Cẩm Mỹ',
    level: 3,
  },
  {
    code: 'vn-lan-kig',
    name: 'Kiến Tường',
    level: 3,
  },
  {
    code: 'vn-hcm-qu8',
    name: 'Quận 8',
    level: 3,
  },
  {
    code: 'vn-dtp-houh',
    name: 'Hồng Ngự',
    level: 3,
  },
  {
    code: 'vn-hcm-qu7',
    name: 'Quận 7',
    level: 3,
  },
  {
    code: 'vn-btn-htn',
    name: 'Hàm Thuận Nam',
    level: 3,
  },
  {
    code: 'vn-agg-anu',
    name: 'An Phú',
    level: 3,
  },
  {
    code: 'vn-hcm-bta',
    name: 'Bình Tân',
    level: 3,
  },
  {
    code: 'vn-agg-tau',
    name: 'Tân Châu',
    level: 3,
  },
  {
    code: 'vn-lan-vig',
    name: 'Vĩnh Hưng',
    level: 3,
  },
  {
    code: 'vn-hcm-qu6',
    name: 'Quận 6',
    level: 3,
  },
  {
    code: 'vn-hcm-qu2',
    name: 'Quận 2',
    level: 3,
  },
  {
    code: 'vn-lan-dua',
    name: 'Đức Hòa',
    level: 3,
  },
  {
    code: 'vn-lan-due',
    name: 'Đức Huệ',
    level: 3,
  },
  {
    code: 'vn-hcm-qu5',
    name: 'Quận 5',
    level: 3,
  },
  {
    code: 'vn-dtp-houtx',
    name: 'Hồng Ngự',
    level: 3,
  },
  {
    code: 'vn-hcm-qu4',
    name: 'Quận 4',
    level: 3,
  },
  {
    code: 'vn-hcm-qu1',
    name: 'Quận 1',
    level: 3,
  },
  {
    code: 'vn-hcm-q11',
    name: 'Quận 11',
    level: 3,
  },
  {
    code: 'vn-hcm-tau',
    name: 'Tân Phú',
    level: 3,
  },
  {
    code: 'vn-hcm-q10',
    name: 'Quận 10',
    level: 3,
  },
  {
    code: 'vn-hcm-qu9',
    name: 'Quận 9',
    level: 3,
  },
  {
    code: 'vn-hcm-qu3',
    name: 'Quận 3',
    level: 3,
  },
  {
    code: 'vn-dni-xuc',
    name: 'Xuân Lộc',
    level: 3,
  },
  {
    code: 'vn-hcm-tah',
    name: 'Tân Bình',
    level: 3,
  },
  {
    code: 'vn-btn-pht',
    name: 'Phan Thiết',
    level: 3,
  },
  {
    code: 'vn-dtp-thg',
    name: 'Tân Hồng',
    level: 3,
  },
  {
    code: 'vn-hcm-bth',
    name: 'Bình Thạnh',
    level: 3,
  },
  {
    code: 'vn-hcm-phn',
    name: 'Phú Nhuận',
    level: 3,
  },
  {
    code: 'vn-hcm-gop',
    name: 'Gò Vấp',
    level: 3,
  },
  {
    code: 'vn-hcm-thc',
    name: 'Thủ Đức',
    level: 3,
  },
  {
    code: 'vn-hcm-q12',
    name: 'Quận 12',
    level: 3,
  },
  {
    code: 'vn-dni-bia',
    name: 'Biên Hòa',
    level: 3,
  },
  {
    code: 'vn-hcm-hon',
    name: 'Hóc Môn',
    level: 3,
  },
  {
    code: 'vn-dni-lok',
    name: 'Long Khánh',
    level: 3,
  },
  {
    code: 'vn-dni-tht',
    name: 'Thống Nhất',
    level: 3,
  },
  {
    code: 'vn-dni-trm',
    name: 'Trảng Bom',
    level: 3,
  },
  {
    code: 'vn-bdg-din',
    name: 'Dĩ An',
    level: 3,
  },
  {
    code: 'vn-bdg-thn',
    name: 'Thuận An',
    level: 3,
  },
  {
    code: 'vn-btn-tah',
    name: 'Tánh Linh',
    level: 3,
  },
  {
    code: 'vn-hcm-cui',
    name: 'Củ Chi',
    level: 3,
  },
  {
    code: 'vn-bdg-thu',
    name: 'Thủ Dầu Một',
    level: 3,
  },
  {
    code: 'vn-btn-htb',
    name: 'Hàm Thuận Bắc',
    level: 3,
  },
  {
    code: 'vn-bdg-tan',
    name: 'Tân Uyên',
    level: 3,
  },
  {
    code: 'vn-tnh-trg',
    name: 'Trảng Bàng',
    level: 3,
  },
  {
    code: 'vn-dni-viu',
    name: 'Vĩnh Cửu',
    level: 3,
  },
  {
    code: 'vn-btn-bah',
    name: 'Bắc Bình',
    level: 3,
  },
  {
    code: 'vn-btn-duh',
    name: 'Đức Linh',
    level: 3,
  },
  {
    code: 'vn-bdg-ban',
    name: 'Bắc Tân Uyên',
    level: 3,
  },
  {
    code: 'vn-dni-din',
    name: 'Định Quán',
    level: 3,
  },
  {
    code: 'vn-bdg-bet',
    name: 'Bến Cát',
    level: 3,
  },
  {
    code: 'vn-tnh-gou',
    name: 'Gò Dầu',
    level: 3,
  },
  {
    code: 'vn-tnh-beu',
    name: 'Bến Cầu',
    level: 3,
  },
  {
    code: 'vn-btn-tug',
    name: 'Tuy Phong',
    level: 3,
  },
  {
    code: 'vn-bdg-dag',
    name: 'Dầu Tiếng',
    level: 3,
  },
  {
    code: 'vn-bdg-bag',
    name: 'Bàu Bàng',
    level: 3,
  },
  {
    code: 'vn-dni-tau',
    name: 'Tân Phú',
    level: 3,
  },
  {
    code: 'vn-tnh-chh',
    name: 'Châu Thành',
    level: 3,
  },
  {
    code: 'vn-bdg-pho',
    name: 'Phú Giáo',
    level: 3,
  },
  {
    code: 'vn-tnh-duh',
    name: 'Dương Minh Châu',
    level: 3,
  },
  {
    code: 'vn-tnh-hoh',
    name: 'Hòa Thành',
    level: 3,
  },
  {
    code: 'vn-ldg-dih',
    name: 'Di Linh',
    level: 3,
  },
  {
    code: 'vn-tnh-tah',
    name: 'Tây Ninh',
    level: 3,
  },
  {
    code: 'vn-bpc-dou',
    name: 'Đồng Phú',
    level: 3,
  },
  {
    code: 'vn-ntn-thm',
    name: 'Thuận Nam',
    level: 3,
  },
  {
    code: 'vn-ldg-dai',
    name: 'Đạ Huoai',
    level: 3,
  },
  {
    code: 'vn-bpc-chh',
    name: 'Chơn Thành',
    level: 3,
  },
  {
    code: 'vn-ldg-bam',
    name: 'Bảo Lâm',
    level: 3,
  },
  {
    code: 'vn-tnh-tan',
    name: 'Tân Biên',
    level: 3,
  },
  {
    code: 'vn-tnh-tau',
    name: 'Tân Châu',
    level: 3,
  },
  {
    code: 'vn-ldg-dah',
    name: 'Đạ Tẻh',
    level: 3,
  },
  {
    code: 'vn-ldg-bac',
    name: 'Bảo Lộc',
    level: 3,
  },
  {
    code: 'vn-bpc-doi',
    name: 'Đồng Xoài',
    level: 3,
  },
  {
    code: 'vn-bpc-hon',
    name: 'Hớn Quản',
    level: 3,
  },
  {
    code: 'vn-ntn-nic',
    name: 'Ninh Phước',
    level: 3,
  },
  {
    code: 'vn-ntn-nin',
    name: 'Ninh Sơn',
    level: 3,
  },
  {
    code: 'vn-bpc-bug',
    name: 'Bù Đăng',
    level: 3,
  },
  {
    code: 'vn-ldg-dug',
    name: 'Đức Trọng',
    level: 3,
  },
  {
    code: 'vn-ldg-can',
    name: 'Cát Tiên',
    level: 3,
  },
  {
    code: 'vn-ntn-php',
    name: 'Phan Rang-Tháp Chàm',
    level: 3,
  },
  {
    code: 'vn-ntn-nii',
    name: 'Ninh Hải',
    level: 3,
  },
  {
    code: 'vn-bpc-phg',
    name: 'Phú Riềng',
    level: 3,
  },
  {
    code: 'vn-bpc-big',
    name: 'Bình Long',
    level: 3,
  },
  {
    code: 'vn-ntn-thc',
    name: 'Thuận Bắc',
    level: 3,
  },
  {
    code: 'vn-ldg-dog',
    name: 'Đơn Dương',
    level: 3,
  },
  {
    code: 'vn-ldg-laa',
    name: 'Lâm Hà',
    level: 3,
  },
  {
    code: 'vn-bpc-loh',
    name: 'Lộc Ninh',
    level: 3,
  },
  {
    code: 'vn-ntn-bai',
    name: 'Bác Ái',
    level: 3,
  },
  {
    code: 'vn-dnk-dap',
    name: "Đắk R'lấp",
    level: 3,
  },
  {
    code: 'vn-bpc-phl',
    name: 'Phước Long',
    level: 3,
  },
  {
    code: 'vn-dnk-dgg',
    name: 'Đắk Glong',
    level: 3,
  },
  {
    code: 'vn-kha-cah',
    name: 'Cam Ranh',
    level: 3,
  },
  {
    code: 'vn-ldg-dat',
    name: 'Đà Lạt',
    level: 3,
  },
  {
    code: 'vn-bpc-bua',
    name: 'Bù Gia Mập',
    level: 3,
  },
  {
    code: 'vn-ldg-dag',
    name: 'Đam Rông',
    level: 3,
  },
  {
    code: 'vn-bpc-bup',
    name: 'Bù Đốp',
    level: 3,
  },
  {
    code: 'vn-dnk-gia',
    name: 'Gia Nghĩa',
    level: 3,
  },
  {
    code: 'vn-kha-khn',
    name: 'Khánh Sơn',
    level: 3,
  },
  {
    code: 'vn-dnk-tuc',
    name: 'Tuy Đức',
    level: 3,
  },
  {
    code: 'vn-kha-cam',
    name: 'Cam Lâm',
    level: 3,
  },
  {
    code: 'vn-ldg-lag',
    name: 'Lạc Dương',
    level: 3,
  },
  {
    code: 'vn-dnk-dsg',
    name: 'Đăk Song',
    level: 3,
  },
  {
    code: 'vn-kha-khh',
    name: 'Khánh Vĩnh',
    level: 3,
  },
  {
    code: 'vn-kha-nhg',
    name: 'Nha Trang',
    level: 3,
  },
  {
    code: 'vn-dlk-lak',
    name: 'Lắk',
    level: 3,
  },
  {
    code: 'vn-kha-dih',
    name: 'Diên Khánh',
    level: 3,
  },
  {
    code: 'vn-dnk-kro',
    name: 'Krông Nô',
    level: 3,
  },
  {
    code: 'vn-dlk-kbo',
    name: 'Krông Bông',
    level: 3,
  },
  {
    code: 'vn-dnk-dal',
    name: 'Đắk Mil',
    level: 3,
  },
  {
    code: 'vn-kha-nia',
    name: 'Ninh Hòa',
    level: 3,
  },
  {
    code: 'vn-dlk-kra',
    name: 'Krông Ana',
    level: 3,
  },
  {
    code: 'vn-dlk-mdk',
    name: "M'Đrăk",
    level: 3,
  },
  {
    code: 'vn-dlk-cun',
    name: 'Cư Kuin',
    level: 3,
  },
  {
    code: 'vn-dlk-kak',
    name: 'Krông Pắk',
    level: 3,
  },
  {
    code: 'vn-dnk-cut',
    name: 'Cư Jút',
    level: 3,
  },
  {
    code: 'vn-dlk-bua',
    name: 'Buôn Ma Thuột',
    level: 3,
  },
  {
    code: 'vn-kha-vah',
    name: 'Vạn Ninh',
    level: 3,
  },
  {
    code: 'vn-dlk-ear',
    name: 'Ea Kar',
    level: 3,
  },
  {
    code: 'vn-dlk-bun',
    name: 'Buôn Đôn',
    level: 3,
  },
  {
    code: 'vn-pyn-soh',
    name: 'Sông Hinh',
    level: 3,
  },
  {
    code: 'vn-dlk-cur',
    name: "Cư M'gar",
    level: 3,
  },
  {
    code: 'vn-dlk-buo',
    name: 'Buôn Hồ',
    level: 3,
  },
  {
    code: 'vn-pyn-taa',
    name: 'Tây Hòa',
    level: 3,
  },
  {
    code: 'vn-dlk-krg',
    name: 'Krông Năng',
    level: 3,
  },
  {
    code: 'vn-pyn-doa',
    name: 'Đông Hòa',
    level: 3,
  },
  {
    code: 'vn-dlk-kuk',
    name: 'Krông Búk',
    level: 3,
  },
  {
    code: 'vn-dlk-eap',
    name: 'Ea Súp',
    level: 3,
  },
  {
    code: 'vn-pyn-pha',
    name: 'Phú Hòa',
    level: 3,
  },
  {
    code: 'vn-gli-kra',
    name: 'Krông Pa',
    level: 3,
  },
  {
    code: 'vn-pyn-tua',
    name: 'Tuy Hòa',
    level: 3,
  },
  {
    code: 'vn-pyn-soa',
    name: 'Sơn Hòa',
    level: 3,
  },
  {
    code: 'vn-dlk-eao',
    name: "Ea H'leo",
    level: 3,
  },
  {
    code: 'vn-pyn-tun',
    name: 'Tuy An',
    level: 3,
  },
  {
    code: 'vn-gli-aya',
    name: 'Ayun Pa',
    level: 3,
  },
  {
    code: 'vn-pyn-don',
    name: 'Đồng Xuân',
    level: 3,
  },
  {
    code: 'vn-gli-chp',
    name: 'Chư Prông',
    level: 3,
  },
  {
    code: 'vn-gli-phn',
    name: 'Phú Thiện',
    level: 3,
  },
  {
    code: 'vn-pyn-sou',
    name: 'Sông Cầu',
    level: 3,
  },
  {
    code: 'vn-gli-iaa',
    name: 'Ia Pa',
    level: 3,
  },
  {
    code: 'vn-gli-chh',
    name: 'Chư Pưh',
    level: 3,
  },
  {
    code: 'vn-bdh-vah',
    name: 'Vân Canh',
    level: 3,
  },
  {
    code: 'vn-gli-che',
    name: 'Chư Sê',
    level: 3,
  },
  {
    code: 'vn-gli-koo',
    name: 'Kông Chro',
    level: 3,
  },
  {
    code: 'vn-bdh-qun',
    name: 'Quy Nhơn',
    level: 3,
  },
  {
    code: 'vn-gli-duo',
    name: 'Đức Cơ',
    level: 3,
  },
  {
    code: 'vn-gli-mag',
    name: 'Mang Yang',
    level: 3,
  },
  {
    code: 'vn-bdh-tuc',
    name: 'Tuy Phước',
    level: 3,
  },
  {
    code: 'vn-bdh-ann',
    name: 'An Nhơn',
    level: 3,
  },
  {
    code: 'vn-bdh-tan',
    name: 'Tây Sơn',
    level: 3,
  },
  {
    code: 'vn-gli-dao',
    name: 'Đak Pơ',
    level: 3,
  },
  {
    code: 'vn-gli-plk',
    name: 'Pleiku',
    level: 3,
  },
  {
    code: 'vn-gli-daa',
    name: 'Đắk Đoa',
    level: 3,
  },
  {
    code: 'vn-gli-iai',
    name: 'Ia Grai',
    level: 3,
  },
  {
    code: 'vn-bdh-pht',
    name: 'Phù Cát',
    level: 3,
  },
  {
    code: 'vn-gli-ane',
    name: 'An Khê',
    level: 3,
  },
  {
    code: 'vn-ktm-say',
    name: 'Sa Thầy',
    level: 3,
  },
  {
    code: 'vn-gli-kbg',
    name: "K'Bang",
    level: 3,
  },
  {
    code: 'vn-bdh-vih',
    name: 'Vĩnh Thạnh',
    level: 3,
  },
  {
    code: 'vn-gli-cpa',
    name: 'Chư Păh',
    level: 3,
  },
  {
    code: 'vn-bdh-phy',
    name: 'Phù Mỹ',
    level: 3,
  },
  {
    code: 'vn-bdh-han',
    name: 'Hoài Ân',
    level: 3,
  },
  {
    code: 'vn-ktm-kom',
    name: 'Kon Tum',
    level: 3,
  },
  {
    code: 'vn-ktm-koy',
    name: 'Kon Rẫy',
    level: 3,
  },
  {
    code: 'vn-bdh-hon',
    name: 'Hoài Nhơn',
    level: 3,
  },
  {
    code: 'vn-bdh-ano',
    name: 'An Lão',
    level: 3,
  },
  {
    code: 'vn-ktm-daa',
    name: 'Đắk Hà',
    level: 3,
  },
  {
    code: 'vn-ktm-ngi',
    name: 'Ngọc Hồi',
    level: 3,
  },
  {
    code: 'vn-ktm-dao',
    name: 'Đăk Tô',
    level: 3,
  },
  {
    code: 'vn-qni-bao',
    name: 'Ba Tơ',
    level: 3,
  },
  {
    code: 'vn-ktm-kog',
    name: 'Kon Plông',
    level: 3,
  },
  {
    code: 'vn-qni-duo',
    name: 'Đức Phổ',
    level: 3,
  },
  {
    code: 'vn-ktm-tuo',
    name: 'Tu Mơ Rông',
    level: 3,
  },
  {
    code: 'vn-qni-soa',
    name: 'Sơn Hà',
    level: 3,
  },
  {
    code: 'vn-qni-soy',
    name: 'Sơn Tây',
    level: 3,
  },
  {
    code: 'vn-qni-ngh',
    name: 'Nghĩa Hành',
    level: 3,
  },
  {
    code: 'vn-qni-mig',
    name: 'Minh Long',
    level: 3,
  },
  {
    code: 'vn-ktm-dai',
    name: 'Đắk Glei',
    level: 3,
  },
  {
    code: 'vn-qni-moc',
    name: 'Mộ Đức',
    level: 3,
  },
  {
    code: 'vn-qnm-naa',
    name: 'Nam Trà My',
    level: 3,
  },
  {
    code: 'vn-qni-tua',
    name: 'Tư Nghĩa',
    level: 3,
  },
  {
    code: 'vn-qni-taa',
    name: 'Tây Trà',
    level: 3,
  },
  {
    code: 'vn-qni-qui',
    name: 'Quảng Ngãi',
    level: 3,
  },
  {
    code: 'vn-qni-trg',
    name: 'Trà Bồng',
    level: 3,
  },
  {
    code: 'vn-qnm-baa',
    name: 'Bắc Trà My',
    level: 3,
  },
  {
    code: 'vn-qni-soh',
    name: 'Sơn Tịnh',
    level: 3,
  },
  {
    code: 'vn-qnm-phn',
    name: 'Phước Sơn',
    level: 3,
  },
  {
    code: 'vn-qni-bin',
    name: 'Bình Sơn',
    level: 3,
  },
  {
    code: 'vn-qnm-nuh',
    name: 'Núi Thành',
    level: 3,
  },
  {
    code: 'vn-qni-lyn',
    name: 'Lý Sơn',
    level: 3,
  },
  {
    code: 'vn-qnm-tic',
    name: 'Tiên Phước',
    level: 3,
  },
  {
    code: 'vn-qnm-nag',
    name: 'Nam Giang',
    level: 3,
  },
  {
    code: 'vn-qnm-phh',
    name: 'Phú Ninh',
    level: 3,
  },
  {
    code: 'vn-qnm-hic',
    name: 'Hiệp Đức',
    level: 3,
  },
  {
    code: 'vn-qnm-tay',
    name: 'Tam Kỳ',
    level: 3,
  },
  {
    code: 'vn-qnm-non',
    name: 'Nông Sơn',
    level: 3,
  },
  {
    code: 'vn-qnm-thh',
    name: 'Thăng Bình',
    level: 3,
  },
  {
    code: 'vn-qnm-qun',
    name: 'Quế Sơn',
    level: 3,
  },
  {
    code: 'vn-qnm-dun',
    name: 'Duy Xuyên',
    level: 3,
  },
  {
    code: 'vn-qnm-dac',
    name: 'Đại Lộc',
    level: 3,
  },
  {
    code: 'vn-qnm-tag',
    name: 'Tây Giang',
    level: 3,
  },
  {
    code: 'vn-qnm-dog',
    name: 'Đông Giang',
    level: 3,
  },
  {
    code: 'vn-qnm-din',
    name: 'Điện Bàn',
    level: 3,
  },
  {
    code: 'vn-qnm-hon',
    name: 'Hội An',
    level: 3,
  },
  {
    code: 'vn-dng-hog',
    name: 'Hòa Vang',
    level: 3,
  },
  {
    code: 'vn-dng-ngh',
    name: 'Ngũ Hành Sơn',
    level: 3,
  },
  {
    code: 'vn-dng-cae',
    name: 'Cẩm Lệ',
    level: 3,
  },
  {
    code: 'vn-tth-nag',
    name: 'Nam Đông',
    level: 3,
  },
  {
    code: 'vn-tth-ali',
    name: 'A Lưới',
    level: 3,
  },
  {
    code: 'vn-dng-hau',
    name: 'Hải Châu',
    level: 3,
  },
  {
    code: 'vn-dng-the',
    name: 'Thanh Khê',
    level: 3,
  },
  {
    code: 'vn-dng-liu',
    name: 'Liên Chiểu',
    level: 3,
  },
  {
    code: 'vn-dng-soa',
    name: 'Sơn Trà',
    level: 3,
  },
  {
    code: 'vn-tth-huy',
    name: 'Hương Thủy',
    level: 3,
  },
  {
    code: 'vn-tth-phc',
    name: 'Phú Lộc',
    level: 3,
  },
  {
    code: 'vn-tth-hua',
    name: 'Hương Trà',
    level: 3,
  },
  {
    code: 'vn-qti-dag',
    name: 'Đa Krông',
    level: 3,
  },
  {
    code: 'vn-tth-phg',
    name: 'Phú Vang',
    level: 3,
  },
  {
    code: 'vn-tth-phn',
    name: 'Phong Điền',
    level: 3,
  },
  {
    code: 'vn-tth-hue',
    name: 'Huế',
    level: 3,
  },
  {
    code: 'vn-qti-hua',
    name: 'Hướng Hóa',
    level: 3,
  },
  {
    code: 'vn-tth-qun',
    name: 'Quảng Điền',
    level: 3,
  },
  {
    code: 'vn-qti-hag',
    name: 'Hải Lăng',
    level: 3,
  },
  {
    code: 'vn-qti-trg',
    name: 'Triệu Phong',
    level: 3,
  },
  {
    code: 'vn-qti-cao',
    name: 'Cam Lộ',
    level: 3,
  },
  {
    code: 'vn-qti-qui',
    name: 'Quảng Trị',
    level: 3,
  },
  {
    code: 'vn-qti-doa',
    name: 'Đông Hà',
    level: 3,
  },
  {
    code: 'vn-qti-gih',
    name: 'Gio Linh',
    level: 3,
  },
  {
    code: 'vn-qti-vih',
    name: 'Vĩnh Linh',
    level: 3,
  },
  {
    code: 'vn-qbh-ley',
    name: 'Lệ Thủy',
    level: 3,
  },
  {
    code: 'vn-qbh-qnh',
    name: 'Quảng Ninh',
    level: 3,
  },
  {
    code: 'vn-qti-coo',
    name: 'Cồn Cỏ',
    level: 3,
  },
  {
    code: 'vn-qbh-boh',
    name: 'Bố Trạch',
    level: 3,
  },
  {
    code: 'vn-qbh-doi',
    name: 'Đồng Hới',
    level: 3,
  },
  {
    code: 'vn-qbh-mia',
    name: 'Minh Hóa',
    level: 3,
  },
  {
    code: 'vn-qbh-ban',
    name: 'Ba Đồn',
    level: 3,
  },
  {
    code: 'vn-qbh-tua',
    name: 'Tuyên Hóa',
    level: 3,
  },
  {
    code: 'vn-qbh-qth',
    name: 'Quảng Trạch',
    level: 3,
  },
  {
    code: 'vn-hth-kyhh',
    name: 'Kỳ Anh',
    level: 3,
  },
  {
    code: 'vn-hth-kyhtx',
    name: 'Kỳ Anh',
    level: 3,
  },
  {
    code: 'vn-hth-hue',
    name: 'Hương Khê',
    level: 3,
  },
  {
    code: 'vn-hth-can',
    name: 'Cẩm Xuyên',
    level: 3,
  },
  {
    code: 'vn-hth-vug',
    name: 'Vũ Quang',
    level: 3,
  },
  {
    code: 'vn-hth-tha',
    name: 'Thạch Hà',
    level: 3,
  },
  {
    code: 'vn-hth-hun',
    name: 'Hương Sơn',
    level: 3,
  },
  {
    code: 'vn-hth-hah',
    name: 'Hà Tĩnh',
    level: 3,
  },
  {
    code: 'vn-hth-cac',
    name: 'Can Lộc',
    level: 3,
  },
  {
    code: 'vn-hth-duo',
    name: 'Đức Thọ',
    level: 3,
  },
  {
    code: 'vn-hth-loa',
    name: 'Lộc Hà',
    level: 3,
  },
  {
    code: 'vn-hth-hoh',
    name: 'Hồng Lĩnh',
    level: 3,
  },
  {
    code: 'vn-hth-ngn',
    name: 'Nghi Xuân',
    level: 3,
  },
  {
    code: 'vn-nan-nan',
    name: 'Nam Đàn',
    level: 3,
  },
  {
    code: 'vn-nan-hun',
    name: 'Hưng Nguyên',
    level: 3,
  },
  {
    code: 'vn-nan-thg',
    name: 'Thanh Chương',
    level: 3,
  },
  {
    code: 'vn-nan-vih',
    name: 'Vinh',
    level: 3,
  },
  {
    code: 'vn-nan-ngc',
    name: 'Nghi Lộc',
    level: 3,
  },
  {
    code: 'vn-nan-cuo',
    name: 'Cửa Lò',
    level: 3,
  },
  {
    code: 'vn-nan-ann',
    name: 'Anh Sơn',
    level: 3,
  },
  {
    code: 'vn-nan-cog',
    name: 'Con Cuông',
    level: 3,
  },
  {
    code: 'vn-nan-dog',
    name: 'Đô Lương',
    level: 3,
  },
  {
    code: 'vn-nan-diu',
    name: 'Diễn Châu',
    level: 3,
  },
  {
    code: 'vn-nan-yeh',
    name: 'Yên Thành',
    level: 3,
  },
  {
    code: 'vn-nan-tay',
    name: 'Tân Kỳ',
    level: 3,
  },
  {
    code: 'vn-nan-tug',
    name: 'Tương Dương',
    level: 3,
  },
  {
    code: 'vn-nan-qlu',
    name: 'Quỳnh Lưu',
    level: 3,
  },
  {
    code: 'vn-nan-kyn',
    name: 'Kỳ Sơn',
    level: 3,
  },
  {
    code: 'vn-nan-qup',
    name: 'Quỳ Hợp',
    level: 3,
  },
  {
    code: 'vn-nan-ngn',
    name: 'Nghĩa Đàn',
    level: 3,
  },
  {
    code: 'vn-nan-hoi',
    name: 'Hoàng Mai',
    level: 3,
  },
  {
    code: 'vn-nan-tha',
    name: 'Thái Hòa',
    level: 3,
  },
  {
    code: 'vn-tha-tia',
    name: 'Tĩnh Gia',
    level: 3,
  },
  {
    code: 'vn-nan-qcu',
    name: 'Quỳ Châu',
    level: 3,
  },
  {
    code: 'vn-tha-nhh',
    name: 'Như Thanh',
    level: 3,
  },
  {
    code: 'vn-nan-qug',
    name: 'Quế Phong',
    level: 3,
  },
  {
    code: 'vn-tha-nhn',
    name: 'Như Xuân',
    level: 3,
  },
  {
    code: 'vn-tha-nog',
    name: 'Nông Cống',
    level: 3,
  },
  {
    code: 'vn-tha-qug',
    name: 'Quảng Xương',
    level: 3,
  },
  {
    code: 'vn-tha-thx',
    name: 'Thường Xuân',
    level: 3,
  },
  {
    code: 'vn-tha-trn',
    name: 'Triệu Sơn',
    level: 3,
  },
  {
    code: 'vn-tha-san',
    name: 'Sầm Sơn',
    level: 3,
  },
  {
    code: 'vn-tha-don',
    name: 'Đông Sơn',
    level: 3,
  },
  {
    code: 'vn-tha-tha',
    name: 'Thanh Hóa',
    level: 3,
  },
  {
    code: 'vn-tha-hoa',
    name: 'Hoằng Hóa',
    level: 3,
  },
  {
    code: 'vn-tha-tox',
    name: 'Thọ Xuân',
    level: 3,
  },
  {
    code: 'vn-tha-thi',
    name: 'Thiệu Hóa',
    level: 3,
  },
  {
    code: 'vn-tha-hac',
    name: 'Hậu Lộc',
    level: 3,
  },
  {
    code: 'vn-nbh-kin',
    name: 'Kim Sơn',
    level: 3,
  },
  {
    code: 'vn-tha-ngc',
    name: 'Ngọc Lặc',
    level: 3,
  },
  {
    code: 'vn-tha-yeh',
    name: 'Yên Định',
    level: 3,
  },
  {
    code: 'vn-ndh-ngg',
    name: 'Nghĩa Hưng',
    level: 3,
  },
  {
    code: 'vn-tha-ngn',
    name: 'Nga Sơn',
    level: 3,
  },
  {
    code: 'vn-tha-hag',
    name: 'Hà Trung',
    level: 3,
  },
  {
    code: 'vn-tha-vic',
    name: 'Vĩnh Lộc',
    level: 3,
  },
  {
    code: 'vn-tha-lah',
    name: 'Lang Chánh',
    level: 3,
  },
  {
    code: 'vn-ndh-hau',
    name: 'Hải Hậu',
    level: 3,
  },
  {
    code: 'vn-tha-thh',
    name: 'Thạch Thành',
    level: 3,
  },
  {
    code: 'vn-tha-bin',
    name: 'Bỉm Sơn',
    level: 3,
  },
  {
    code: 'vn-nbh-yeo',
    name: 'Yên Mô',
    level: 3,
  },
  {
    code: 'vn-tha-cay',
    name: 'Cẩm Thủy',
    level: 3,
  },
  {
    code: 'vn-tha-qun',
    name: 'Quan Sơn',
    level: 3,
  },
  {
    code: 'vn-nbh-tap',
    name: 'Tam Điệp',
    level: 3,
  },
  {
    code: 'vn-nbh-yeh',
    name: 'Yên Khánh',
    level: 3,
  },
  {
    code: 'vn-ndh-trh',
    name: 'Trực Ninh',
    level: 3,
  },
  {
    code: 'vn-nbh-nhn',
    name: 'Nho Quan',
    level: 3,
  },
  {
    code: 'vn-nbh-hou',
    name: 'Hoa Lư',
    level: 3,
  },
  {
    code: 'vn-ndh-giy',
    name: 'Giao Thủy',
    level: 3,
  },
  {
    code: 'vn-tha-bac',
    name: 'Bá Thước',
    level: 3,
  },
  {
    code: 'vn-nbh-nih',
    name: 'Ninh Bình',
    level: 3,
  },
  {
    code: 'vn-ndh-yyn',
    name: 'Ý Yên',
    level: 3,
  },
  {
    code: 'vn-ndh-xug',
    name: 'Xuân Trường',
    level: 3,
  },
  {
    code: 'vn-nbh-gin',
    name: 'Gia Viễn',
    level: 3,
  },
  {
    code: 'vn-ndh-nac',
    name: 'Nam Trực',
    level: 3,
  },
  {
    code: 'vn-tbh-tii',
    name: 'Tiền Hải',
    level: 3,
  },
  {
    code: 'vn-tbh-kig',
    name: 'Kiến Xương',
    level: 3,
  },
  {
    code: 'vn-ndh-vun',
    name: 'Vụ Bản',
    level: 3,
  },
  {
    code: 'vn-tha-qua',
    name: 'Quan Hóa',
    level: 3,
  },
  {
    code: 'vn-hbh-yey',
    name: 'Yên Thủy',
    level: 3,
  },
  {
    code: 'vn-tbh-vuu',
    name: 'Vũ Thư',
    level: 3,
  },
  {
    code: 'vn-hbh-lan',
    name: 'Lạc Sơn',
    level: 3,
  },
  {
    code: 'vn-hnm-thm',
    name: 'Thanh Liêm',
    level: 3,
  },
  {
    code: 'vn-hbh-lay',
    name: 'Lạc Thủy',
    level: 3,
  },
  {
    code: 'vn-tha-mut',
    name: 'Mường Lát',
    level: 3,
  },
  {
    code: 'vn-ndh-nah',
    name: 'Nam Định',
    level: 3,
  },
  {
    code: 'vn-hnm-bic',
    name: 'Bình Lục',
    level: 3,
  },
  {
    code: 'vn-tbh-thh',
    name: 'Thái Bình',
    level: 3,
  },
  {
    code: 'vn-ndh-myc',
    name: 'Mỹ Lộc',
    level: 3,
  },
  {
    code: 'vn-qnh-coo',
    name: 'Cô Tô',
    level: 3,
  },
  {
    code: 'vn-tbh-thy',
    name: 'Thái Thụy',
    level: 3,
  },
  {
    code: 'vn-hbh-tac',
    name: 'Tân Lạc',
    level: 3,
  },
  {
    code: 'vn-hnm-lyn',
    name: 'Lý Nhân',
    level: 3,
  },
  {
    code: 'vn-hnm-kig',
    name: 'Kim Bảng',
    level: 3,
  },
  {
    code: 'vn-tbh-dog',
    name: 'Đông Hưng',
    level: 3,
  },
  {
    code: 'vn-hnm-phy',
    name: 'Phủ Lý',
    level: 3,
  },
  {
    code: 'vn-tbh-hua',
    name: 'Hưng Hà',
    level: 3,
  },
  {
    code: 'vn-hbh-kii',
    name: 'Kim Bôi',
    level: 3,
  },
  {
    code: 'vn-hnm-dun',
    name: 'Duy Tiên',
    level: 3,
  },
  {
    code: 'vn-hbh-mau',
    name: 'Mai Châu',
    level: 3,
  },
  {
    code: 'vn-hni-myc',
    name: 'Mỹ Đức',
    level: 3,
  },
  {
    code: 'vn-tbh-quu',
    name: 'Quỳnh Phụ',
    level: 3,
  },
  {
    code: 'vn-sla-vao',
    name: 'Vân Hồ',
    level: 3,
  },
  {
    code: 'vn-hbh-cag',
    name: 'Cao Phong',
    level: 3,
  },
  {
    code: 'vn-hpg-vio',
    name: 'Vĩnh Bảo',
    level: 3,
  },
  {
    code: 'vn-hyn-tiu',
    name: 'Tiên Lữ',
    level: 3,
  },
  {
    code: 'vn-hyn-hun',
    name: 'Hưng Yên',
    level: 3,
  },
  {
    code: 'vn-hni-una',
    name: 'Ứng Hòa',
    level: 3,
  },
  {
    code: 'vn-hpg-tig',
    name: 'Tiên Lãng',
    level: 3,
  },
  {
    code: 'vn-hyn-phu',
    name: 'Phù Cừ',
    level: 3,
  },
  {
    code: 'vn-hni-phn',
    name: 'Phú Xuyên',
    level: 3,
  },
  {
    code: 'vn-sla-sop',
    name: 'Sốp Cộp',
    level: 3,
  },
  {
    code: 'vn-sla-mou',
    name: 'Mộc Châu',
    level: 3,
  },
  {
    code: 'vn-hpg-don',
    name: 'Đồ Sơn',
    level: 3,
  },
  {
    code: 'vn-hyn-kig',
    name: 'Kim Động',
    level: 3,
  },
  {
    code: 'vn-hpg-kiy',
    name: 'Kiến Thụy',
    level: 3,
  },
  {
    code: 'vn-hdg-thn',
    name: 'Thanh Miện',
    level: 3,
  },
  {
    code: 'vn-hpg-cai',
    name: 'Cát Hải',
    level: 3,
  },
  {
    code: 'vn-hdg-nig',
    name: 'Ninh Giang',
    level: 3,
  },
  {
    code: 'vn-qnh-van',
    name: 'Vân Đồn',
    level: 3,
  },
  {
    code: 'vn-hdg-tuy',
    name: 'Tứ Kỳ',
    level: 3,
  },
  {
    code: 'vn-qnh-hag',
    name: 'Hạ Long',
    level: 3,
  },
  {
    code: 'vn-hpg-ano',
    name: 'An Lão',
    level: 3,
  },
  {
    code: 'vn-hyn-ani',
    name: 'Ân Thi',
    level: 3,
  },
  {
    code: 'vn-hpg-duh',
    name: 'Dương Kinh',
    level: 3,
  },
  {
    code: 'vn-hbh-hoh',
    name: 'Hoà Bình',
    level: 3,
  },
  {
    code: 'vn-hbh-dac',
    name: 'Đà Bắc',
    level: 3,
  },
  {
    code: 'vn-hni-ttn',
    name: 'Thường Tín',
    level: 3,
  },
  {
    code: 'vn-hbh-lun',
    name: 'Lương Sơn',
    level: 3,
  },
  {
    code: 'vn-hyn-khu',
    name: 'Khoái Châu',
    level: 3,
  },
  {
    code: 'vn-hpg-kin',
    name: 'Kiến An',
    level: 3,
  },
  {
    code: 'vn-hdg-gic',
    name: 'Gia Lộc',
    level: 3,
  },
  {
    code: 'vn-hpg-han',
    name: 'Hải An',
    level: 3,
  },
  {
    code: 'vn-hbh-kyn',
    name: 'Kỳ Sơn',
    level: 3,
  },
  {
    code: 'vn-hni-thoi',
    name: 'Thanh Oai',
    level: 3,
  },
  {
    code: 'vn-hni-chy',
    name: 'Chương Mỹ',
    level: 3,
  },
  {
    code: 'vn-sla-yeu',
    name: 'Yên Châu',
    level: 3,
  },
  {
    code: 'vn-hdg-tha',
    name: 'Thanh Hà',
    level: 3,
  },
  {
    code: 'vn-qnh-qun',
    name: 'Quảng Yên',
    level: 3,
  },
  {
    code: 'vn-hpg-len',
    name: 'Lê Chân',
    level: 3,
  },
  {
    code: 'vn-hpg-ang',
    name: 'An Dương',
    level: 3,
  },
  {
    code: 'vn-hdg-big',
    name: 'Bình Giang',
    level: 3,
  },
  {
    code: 'vn-hyn-yey',
    name: 'Yên Mỹ',
    level: 3,
  },
  {
    code: 'vn-sla-sma',
    name: 'Sông Mã',
    level: 3,
  },
  {
    code: 'vn-hdg-kih',
    name: 'Kim Thành',
    level: 3,
  },
  {
    code: 'vn-hpg-hog',
    name: 'Hồng Bàng',
    level: 3,
  },
  {
    code: 'vn-hpg-thn',
    name: 'Thuỷ Nguyên',
    level: 3,
  },
  {
    code: 'vn-hyn-myo',
    name: 'Mỹ Hào',
    level: 3,
  },
  {
    code: 'vn-hyn-vag',
    name: 'Văn Giang',
    level: 3,
  },
  {
    code: 'vn-dbn-dbn',
    name: 'Điện Biên',
    level: 3,
  },
  {
    code: 'vn-hdg-hag',
    name: 'Hải Dương',
    level: 3,
  },
  {
    code: 'vn-hni-thti',
    name: 'Thanh Trì',
    level: 3,
  },
  {
    code: 'vn-qnh-caa',
    name: 'Cẩm Phả',
    level: 3,
  },
  {
    code: 'vn-hdg-cag',
    name: 'Cẩm Giàng',
    level: 3,
  },
  {
    code: 'vn-hni-qui',
    name: 'Quốc Oai',
    level: 3,
  },
  {
    code: 'vn-hni-hag',
    name: 'Hà Đông',
    level: 3,
  },
  {
    code: 'vn-pto-thn',
    name: 'Thanh Sơn',
    level: 3,
  },
  {
    code: 'vn-hni-gim',
    name: 'Gia Lâm',
    level: 3,
  },
  {
    code: 'vn-hdg-kin',
    name: 'Kinh Môn',
    level: 3,
  },
  {
    code: 'vn-hyn-vam',
    name: 'Văn Lâm',
    level: 3,
  },
  {
    code: 'vn-hni-hoi',
    name: 'Hoàng Mai',
    level: 3,
  },
  {
    code: 'vn-hni-tht',
    name: 'Thạch Thất',
    level: 3,
  },
  {
    code: 'vn-hni-hoc',
    name: 'Hoài Đức',
    level: 3,
  },
  {
    code: 'vn-hdg-nah',
    name: 'Nam Sách',
    level: 3,
  },
  {
    code: 'vn-sla-man',
    name: 'Mai Sơn',
    level: 3,
  },
  {
    code: 'vn-bnh-lui',
    name: 'Lương Tài',
    level: 3,
  },
  {
    code: 'vn-qnh-hoo',
    name: 'Hoành Bồ',
    level: 3,
  },
  {
    code: 'vn-hni-nau',
    name: 'Nam Từ Liêm',
    level: 3,
  },
  {
    code: 'vn-hni-txn',
    name: 'Thanh Xuân',
    level: 3,
  },
  {
    code: 'vn-bnh-thh',
    name: 'Thuận Thành',
    level: 3,
  },
  {
    code: 'vn-qnh-uoi',
    name: 'Uông Bí',
    level: 3,
  },
  {
    code: 'vn-hni-haa',
    name: 'Hai Bà Trưng',
    level: 3,
  },
  {
    code: 'vn-hni-lon',
    name: 'Long Biên',
    level: 3,
  },
  {
    code: 'vn-hni-doa',
    name: 'Đống Đa',
    level: 3,
  },
  {
    code: 'vn-hni-cay',
    name: 'Cầu Giấy',
    level: 3,
  },
  {
    code: 'vn-pto-thy',
    name: 'Thanh Thủy',
    level: 3,
  },
  {
    code: 'vn-sla-ban',
    name: 'Bắc Yên',
    level: 3,
  },
  {
    code: 'vn-hni-bai',
    name: 'Ba Vì',
    level: 3,
  },
  {
    code: 'vn-qnh-dou',
    name: 'Đông Triều',
    level: 3,
  },
  {
    code: 'vn-bnh-gih',
    name: 'Gia Bình',
    level: 3,
  },
  {
    code: 'vn-pto-tan',
    name: 'Tân Sơn',
    level: 3,
  },
  {
    code: 'vn-hni-bah',
    name: 'Ba Đình',
    level: 3,
  },
  {
    code: 'vn-hni-hom',
    name: 'Hoàn Kiếm',
    level: 3,
  },
  {
    code: 'vn-hdg-chh',
    name: 'Chí Linh',
    level: 3,
  },
  {
    code: 'vn-hni-soy',
    name: 'Sơn Tây',
    level: 3,
  },
  {
    code: 'vn-sla-phn',
    name: 'Phù Yên',
    level: 3,
  },
  {
    code: 'vn-dbn-dbd',
    name: 'Điện Biên Đông',
    level: 3,
  },
  {
    code: 'vn-hni-bau',
    name: 'Bắc Từ Liêm',
    level: 3,
  },
  {
    code: 'vn-hni-tao',
    name: 'Tây Hồ',
    level: 3,
  },
  {
    code: 'vn-hni-pho',
    name: 'Phúc Thọ',
    level: 3,
  },
  {
    code: 'vn-hni-dag',
    name: 'Đan Phượng',
    level: 3,
  },
  {
    code: 'vn-hni-doh',
    name: 'Đông Anh',
    level: 3,
  },
  {
    code: 'vn-bnh-tiu',
    name: 'Tiên Du',
    level: 3,
  },
  {
    code: 'vn-bnh-tun',
    name: 'Từ Sơn',
    level: 3,
  },
  {
    code: 'vn-bnh-quo',
    name: 'Quế Võ',
    level: 3,
  },
  {
    code: 'vn-bnh-bah',
    name: 'Bắc Ninh',
    level: 3,
  },
  {
    code: 'vn-hni-meh',
    name: 'Mê Linh',
    level: 3,
  },
  {
    code: 'vn-bgg-yeg',
    name: 'Yên Dũng',
    level: 3,
  },
  {
    code: 'vn-qnh-bae',
    name: 'Ba Chẽ',
    level: 3,
  },
  {
    code: 'vn-bgg-sog',
    name: 'Sơn Động',
    level: 3,
  },
  {
    code: 'vn-vpc-vig',
    name: 'Vĩnh Tường',
    level: 3,
  },
  {
    code: 'vn-vpc-yec',
    name: 'Yên Lạc',
    level: 3,
  },
  {
    code: 'vn-bnh-yeg',
    name: 'Yên Phong',
    level: 3,
  },
  {
    code: 'vn-bgg-lum',
    name: 'Lục Nam',
    level: 3,
  },
  {
    code: 'vn-hni-son',
    name: 'Sóc Sơn',
    level: 3,
  },
  {
    code: 'vn-qnh-tin',
    name: 'Tiên Yên',
    level: 3,
  },
  {
    code: 'vn-bgg-vin',
    name: 'Việt Yên',
    level: 3,
  },
  {
    code: 'vn-sla-thu',
    name: 'Thuận Châu',
    level: 3,
  },
  {
    code: 'vn-pto-yep',
    name: 'Yên Lập',
    level: 3,
  },
  {
    code: 'vn-vpc-phn',
    name: 'Phúc Yên',
    level: 3,
  },
  {
    code: 'vn-qnh-haa',
    name: 'Hải Hà',
    level: 3,
  },
  {
    code: 'vn-vpc-bin',
    name: 'Bình Xuyên',
    level: 3,
  },
  {
    code: 'vn-pto-tag',
    name: 'Tam Nông',
    level: 3,
  },
  {
    code: 'vn-qnh-daa',
    name: 'Đầm Hà',
    level: 3,
  },
  {
    code: 'vn-bgg-hia',
    name: 'Hiệp Hòa',
    level: 3,
  },
  {
    code: 'vn-qnh-moi',
    name: 'Móng Cái',
    level: 3,
  },
  {
    code: 'vn-sla-soa',
    name: 'Sơn La',
    level: 3,
  },
  {
    code: 'vn-pto-lao',
    name: 'Lâm Thao',
    level: 3,
  },
  {
    code: 'vn-bgg-bag',
    name: 'Bắc Giang',
    level: 3,
  },
  {
    code: 'vn-bgg-lun',
    name: 'Lục Ngạn',
    level: 3,
  },
  {
    code: 'vn-pto-vii',
    name: 'Việt Trì',
    level: 3,
  },
  {
    code: 'vn-bgg-lag',
    name: 'Lạng Giang',
    level: 3,
  },
  {
    code: 'vn-vpc-vin',
    name: 'Vĩnh Yên',
    level: 3,
  },
  {
    code: 'vn-pto-cae',
    name: 'Cẩm Khê',
    level: 3,
  },
  {
    code: 'vn-vpc-tag',
    name: 'Tam Dương',
    level: 3,
  },
  {
    code: 'vn-vpc-lah',
    name: 'Lập Thạch',
    level: 3,
  },
  {
    code: 'vn-sla-mua',
    name: 'Mường La',
    level: 3,
  },
  {
    code: 'vn-bgg-tan',
    name: 'Tân Yên',
    level: 3,
  },
  {
    code: 'vn-lsn-dip',
    name: 'Đình Lập',
    level: 3,
  },
  {
    code: 'vn-pto-tha',
    name: 'Thanh Ba',
    level: 3,
  },
  {
    code: 'vn-ybi-vcn',
    name: 'Văn Chấn',
    level: 3,
  },
  {
    code: 'vn-tnn-phn',
    name: 'Phổ Yên',
    level: 3,
  },
  {
    code: 'vn-vpc-tao',
    name: 'Tam Đảo',
    level: 3,
  },
  {
    code: 'vn-ybi-tru',
    name: 'Trạm Tấu',
    level: 3,
  },
  {
    code: 'vn-pto-pho',
    name: 'Phú Thọ',
    level: 3,
  },
  {
    code: 'vn-dbn-dbp',
    name: 'Điện Biên Phủ',
    level: 3,
  },
  {
    code: 'vn-pto-phh',
    name: 'Phù Ninh',
    level: 3,
  },
  {
    code: 'vn-lsn-hug',
    name: 'Hữu Lũng',
    level: 3,
  },
  {
    code: 'vn-tnn-phh',
    name: 'Phú Bình',
    level: 3,
  },
  {
    code: 'vn-dbn-mug',
    name: 'Mường Ảng',
    level: 3,
  },
  {
    code: 'vn-bgg-yee',
    name: 'Yên Thế',
    level: 3,
  },
  {
    code: 'vn-dbn-tuo',
    name: 'Tuần Giáo',
    level: 3,
  },
  {
    code: 'vn-tnn-dau',
    name: 'Đại Từ',
    level: 3,
  },
  {
    code: 'vn-qnh-biu',
    name: 'Bình Liêu',
    level: 3,
  },
  {
    code: 'vn-tnn-sog',
    name: 'Sông Công',
    level: 3,
  },
  {
    code: 'vn-pto-haa',
    name: 'Hạ Hòa',
    level: 3,
  },
  {
    code: 'vn-tnn-thn',
    name: 'Thái Nguyên',
    level: 3,
  },
  {
    code: 'vn-lsn-loh',
    name: 'Lộc Bình',
    level: 3,
  },
  {
    code: 'vn-tqg-sog',
    name: 'Sơn Dương',
    level: 3,
  },
  {
    code: 'vn-pto-dog',
    name: 'Đoan Hùng',
    level: 3,
  },
  {
    code: 'vn-tnn-doy',
    name: 'Đồng Hỷ',
    level: 3,
  },
  {
    code: 'vn-sla-qui',
    name: 'Quỳnh Nhai',
    level: 3,
  },
  {
    code: 'vn-ybi-trn',
    name: 'Trấn Yên',
    level: 3,
  },
  {
    code: 'vn-lsn-chg',
    name: 'Chi Lăng',
    level: 3,
  },
  {
    code: 'vn-ybi-ngo',
    name: 'Nghĩa Lộ',
    level: 3,
  },
  {
    code: 'vn-dbn-mua',
    name: 'Mường Chà',
    level: 3,
  },
  {
    code: 'vn-tnn-voi',
    name: 'Võ Nhai',
    level: 3,
  },
  {
    code: 'vn-tnn-phg',
    name: 'Phú Lương',
    level: 3,
  },
  {
    code: 'vn-ybi-mug',
    name: 'Mù Căng Chải',
    level: 3,
  },
  {
    code: 'vn-dbn-nao',
    name: 'Nậm Pồ',
    level: 3,
  },
  {
    code: 'vn-tqg-yen',
    name: 'Yên Sơn',
    level: 3,
  },
  {
    code: 'vn-ybi-vyn',
    name: 'Văn Yên',
    level: 3,
  },
  {
    code: 'vn-lsn-ban',
    name: 'Bắc Sơn',
    level: 3,
  },
  {
    code: 'vn-ybi-yeh',
    name: 'Yên Bình',
    level: 3,
  },
  {
    code: 'vn-lcu-thn',
    name: 'Than Uyên',
    level: 3,
  },
  {
    code: 'vn-lsn-van',
    name: 'Văn Quan',
    level: 3,
  },
  {
    code: 'vn-ybi-yei',
    name: 'Yên Bái',
    level: 3,
  },
  {
    code: 'vn-tnn-dia',
    name: 'Định Hóa',
    level: 3,
  },
  {
    code: 'vn-lsn-cac',
    name: 'Cao Lộc',
    level: 3,
  },
  {
    code: 'vn-lsn-lan',
    name: 'Lạng Sơn',
    level: 3,
  },
  {
    code: 'vn-dbn-tua',
    name: 'Tủa Chùa',
    level: 3,
  },
  {
    code: 'vn-tqg-tug',
    name: 'Tuyên Quang',
    level: 3,
  },
  {
    code: 'vn-bkn-chi',
    name: 'Chợ Mới',
    level: 3,
  },
  {
    code: 'vn-tqg-han',
    name: 'Hàm Yên',
    level: 3,
  },
  {
    code: 'vn-lsn-bia',
    name: 'Bình Gia',
    level: 3,
  },
  {
    code: 'vn-lci-van',
    name: 'Văn Bàn',
    level: 3,
  },
  {
    code: 'vn-lsn-vag',
    name: 'Văn Lãng',
    level: 3,
  },
  {
    code: 'vn-ybi-lun',
    name: 'Lục Yên',
    level: 3,
  },
  {
    code: 'vn-bkn-nai',
    name: 'Na Rì',
    level: 3,
  },
  {
    code: 'vn-tqg-cha',
    name: 'Chiêm Hóa',
    level: 3,
  },
  {
    code: 'vn-lcu-tan',
    name: 'Tân Uyên',
    level: 3,
  },
  {
    code: 'vn-bkn-chn',
    name: 'Chợ Đồn',
    level: 3,
  },
  {
    code: 'vn-dbn-muy',
    name: 'Mường Lay',
    level: 3,
  },
  {
    code: 'vn-lcu-sio',
    name: 'Sìn Hồ',
    level: 3,
  },
  {
    code: 'vn-dbn-mue',
    name: 'Mường Nhé',
    level: 3,
  },
  {
    code: 'vn-lcu-nan',
    name: 'Nậm Nhùn',
    level: 3,
  },
  {
    code: 'vn-bkn-ban',
    name: 'Bắc Kạn',
    level: 3,
  },
  {
    code: 'vn-bkn-bag',
    name: 'Bạch Thông',
    level: 3,
  },
  {
    code: 'vn-lci-ban',
    name: 'Bảo Yên',
    level: 3,
  },
  {
    code: 'vn-lci-saa',
    name: 'Sa Pa',
    level: 3,
  },
  {
    code: 'vn-lsn-trh',
    name: 'Tràng Định',
    level: 3,
  },
  {
    code: 'vn-hgg-bag',
    name: 'Bắc Quang',
    level: 3,
  },
  {
    code: 'vn-lcu-mue',
    name: 'Mường Tè',
    level: 3,
  },
  {
    code: 'vn-lcu-tag',
    name: 'Tam Đường',
    level: 3,
  },
  {
    code: 'vn-hgg-quh',
    name: 'Quang Bình',
    level: 3,
  },
  {
    code: 'vn-lci-bag',
    name: 'Bảo Thắng',
    level: 3,
  },
  {
    code: 'vn-tqg-nag',
    name: 'Na Hang',
    level: 3,
  },
  {
    code: 'vn-bkn-bae',
    name: 'Ba Bể',
    level: 3,
  },
  {
    code: 'vn-bkn-ngn',
    name: 'Ngân Sơn',
    level: 3,
  },
  {
    code: 'vn-lci-lai',
    name: 'Lào Cai',
    level: 3,
  },
  {
    code: 'vn-tqg-lah',
    name: 'Lâm Bình',
    level: 3,
  },
  {
    code: 'vn-lci-baa',
    name: 'Bắc Hà',
    level: 3,
  },
  {
    code: 'vn-lcu-lau',
    name: 'Lai Châu',
    level: 3,
  },
  {
    code: 'vn-cbg-thn',
    name: 'Thạch An',
    level: 3,
  },
  {
    code: 'vn-lci-bat',
    name: 'Bát Xát',
    level: 3,
  },
  {
    code: 'vn-lcu-pho',
    name: 'Phong Thổ',
    level: 3,
  },
  {
    code: 'vn-bkn-pam',
    name: 'Pác Nặm',
    level: 3,
  },
  {
    code: 'vn-cbg-pha',
    name: 'Phục Hòa',
    level: 3,
  },
  {
    code: 'vn-hgg-xin',
    name: 'Xín Mần',
    level: 3,
  },
  {
    code: 'vn-hgg-vin',
    name: 'Vị Xuyên',
    level: 3,
  },
  {
    code: 'vn-cbg-ngh',
    name: 'Nguyên Bình',
    level: 3,
  },
  {
    code: 'vn-cbg-hon',
    name: 'Hòa An',
    level: 3,
  },
  {
    code: 'vn-lci-mug',
    name: 'Mường Khương',
    level: 3,
  },
  {
    code: 'vn-hgg-hou',
    name: 'Hoàng Su Phì',
    level: 3,
  },
  {
    code: 'vn-cbg-qun',
    name: 'Quảng Uyên',
    level: 3,
  },
  {
    code: 'vn-cbg-hlg',
    name: 'Hạ Lang',
    level: 3,
  },
  {
    code: 'vn-lci-sia',
    name: 'Si Ma Cai',
    level: 3,
  },
  {
    code: 'vn-hgg-bae',
    name: 'Bắc Mê',
    level: 3,
  },
  {
    code: 'vn-cbg-cag',
    name: 'Cao Bằng',
    level: 3,
  },
  {
    code: 'vn-cbg-bam',
    name: 'Bảo Lâm',
    level: 3,
  },
  {
    code: 'vn-cbg-bac',
    name: 'Bảo Lạc',
    level: 3,
  },
  {
    code: 'vn-cbg-thg',
    name: 'Thông Nông',
    level: 3,
  },
  {
    code: 'vn-cbg-trl',
    name: 'Trà Lĩnh',
    level: 3,
  },
  {
    code: 'vn-cbg-trk',
    name: 'Trùng Khánh',
    level: 3,
  },
  {
    code: 'vn-hgg-hag',
    name: 'Hà Giang',
    level: 3,
  },
  {
    code: 'vn-cbg-hqg',
    name: 'Hà Quảng',
    level: 3,
  },
  {
    code: 'vn-hgg-yeh',
    name: 'Yên Minh',
    level: 3,
  },
  {
    code: 'vn-hgg-qua',
    name: 'Quản Bạ',
    level: 3,
  },
  {
    code: 'vn-hgg-mec',
    name: 'Mèo Vạc',
    level: 3,
  },
  {
    code: 'vn-hgg-don',
    name: 'Đồng Văn',
    level: 3,
  },
]

export { googleMapOptions, level2LocationDetails, level3LocationDetails }
